import React from 'react';
import propTypes from 'prop-types';
import Completion from 'client/styleguide/Graphs/Completion.react';
import makeRef from 'lib/makeRef';

import dashboardGraphValues from './dashboard-graphs.scss';



/**
 * this.props.className will be passed through to the underlying completion graph
 */
export default class SeatUsageGraph extends React.Component {
  static propTypes = {
    value: propTypes.number.isRequired,
    total: propTypes.number.isRequired,
    className: propTypes.string
  };

  constructor() {
    super();

    this.state = {
      hasMounted: false
    };
  }

  componentDidMount() {
    global.requestAnimationFrame(() => {
      global.requestAnimationFrame(() => this.setState({hasMounted: true}));
    });
  }

  makeRef = makeRef.bind(this);

  render() {
    return (
      <div data-ref-name='graphRef' ref={this.makeRef}>
        {this.state.hasMounted ? (
          <Completion
            {...this.props}
            width={parseInt(dashboardGraphValues.seatUsageWidth, 10)}
            height={this.graphRef.parentElement.clientHeight}
          />
        ) : null}
      </div>
    );
  }
}
